/**
 * Barrel export for squad planning utility functions.
 * @module features/squad-planning/utils
 */

export { buildDraftSignedPlayers } from "./buildDraftSignedPlayers";
export { buildFieldPath } from "./buildFieldPath";
export {
  buildActionsMapFromPlayers,
  buildActionsMapFromScenario,
  buildScenarioDetailsMap,
  buildScenarioSignedPlayersMap,
} from "./buildScenarioMaps";
export type { ScenarioAction } from "./buildScenarioMaps";
export {
  EM_DASH,
  formatDurationShort,
  formatEuroShort,
} from "./formatActionValue";
export { computeContractMonths } from "./computeContractMonths";
export {
  computeScenarioDeltas,
  type ScenarioActionEntry,
  type ScenarioDeltas,
} from "./computeScenarioDeltas";
export { getFormationLines, getFormationPositions } from "./formationPositions";
export {
  formatAcademyPlayer,
  formatFirstTeamPlayer,
  formatTargetPlayer,
} from "./formatPlayerRow";
export { deriveTierName, groupPlayersByTier } from "./groupPlayersByTier";
export { formatPositionRoleLabel } from "./formatPositionRoleLabel";
export { mapTransitionToAction } from "./mapTransitionToAction";
export { playerMatchesAnyRole, playerMatchesRole } from "./playerMatchesRole";
export { resolveScenarioAccessDenial } from "./resolveScenarioAccessDenial";
export {
  SCENARIO_ERROR_FALLBACK,
  resolveScenarioErrorMessage,
} from "./resolveScenarioErrorMessage";
